import { render, staticRenderFns } from "./PorletVisorOCR.vue?vue&type=template&id=1b444c56"
import script from "./PorletVisorOCR.vue?vue&type=script&lang=js"
export * from "./PorletVisorOCR.vue?vue&type=script&lang=js"
import style0 from "./PorletVisorOCR.vue?vue&type=style&index=0&id=1b444c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports